<template>
<section>
    <div v-if="loading" class="content content-centered">
        <pulse-loader></pulse-loader>
    </div>
    <div v-show="!loading" class="content">
        <div class="box">
            <div class="box-body">
                <div class="row">
                    <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                        <div class="alert" :class="'alert-' + flashType">
                            {{ flashMessage }}
                        </div>
                    </div>
                </div>
                <div id="details" class="row">
                    <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                        <div class="col-sm-12">
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.cityId)">
                                    <label>City</label>
                                    <select required name="cityId" class="form-control" :disabled="isCityDisable" v-model="fuelExpenses.cityId" v-on:change="getCityId($event.target.value)">
                                        <option value="" disabled>Select City Name</option>
                                        <option v-for="cityId in citys" :value="cityId.id">{{ cityId.name }}
                                        </option>
                                    </select>
                                    <field-messages name="cityId" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">This is required field</div>
                                    </field-messages>
                                </validate>
                            </div>
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.vehicleId)">
                                    <label>Vehicle Number </label>
                                    <select required name="vehicleId" class="form-control" v-model="fuelExpenses.vehicleId">
                                        <option value="" disabled>Select Vehicle Number </option>
                                        <option v-for="vehicleId in vehiclePoints" :value="vehicleId.id">{{ vehicleId.name }}</option>
                                    </select>
                                    <field-messages name="vehicleId" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">This is required field</div>
                                    </field-messages>
                                </validate>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.disel)">
                                    <label>Diesel Quantity (L)</label>
                                    <input type="text" name="disel" class="form-control" required v-model="fuelExpenses.disel" placeholder="Diesel Quantity" pattern="^(?!$)\d{0,10}(?:\.\d{1,2})?$" />
                                    <field-messages name="disel" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">
                                            Diesel Quantity is a required field
                                        </div>
                                        <div slot="pattern">
                                            Only two decimal digits are allowed in the Diesel
                                            Quantity(Max limit 10 digits). (ex:- 123.12)
                                        </div>
                                    </field-messages>
                                </validate>
                            </div>

                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.driverId)">
                                    <label>Driver</label>
                                    <select required name="driverId" class="form-control" v-model="fuelExpenses.driverId">
                                        <option value="" disabled>Select Driver</option>
                                        <option v-for="driverId in driverPoints" :value="driverId.id">
                                            {{ driverId.name }}
                                        </option>
                                    </select>
                                    <field-messages name="driverId" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">This is required field</div>
                                    </field-messages>
                                </validate>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.amount)">
                                    <label>Amount (INR)</label>
                                    <input type="text" name="amount" class="form-control" required v-model="fuelExpenses.amount" placeholder="Amount" pattern="\d{0,10}" />
                                    <field-messages name="amount" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">Amount is a required field</div>
                                        <div slot="pattern">
                                            Numbers are allowed(Max limit 10 digits).
                                        </div>
                                    </field-messages>
                                </validate>
                            </div>

                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.receipt)">
                                    <label>Receipt</label>
                                    <input type="file" name="receipt" required class="form-control" @change="onDocumentchanged" />
                                    <field-messages name="receipt" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">
                                            Please upload less than 3mb Memo Picture
                                        </div>
                                    </field-messages>
                                    <div class="border p-2 mt-3" v-if="$route.params && $route.params._id != '0'">
                                        <a v-bind:href="fuelExpenses.receipt" target="_blank">
                                            View
                                        </a>
                                    </div>
                                </validate>
                            </div>
                        </div>
                    </vue-form>

                    <div class="col-sm-12 text-right">
                        <router-link :to="{ name: 'fuelExpenses' }">
                            <button class="mr-5 btn btn-default" type="button">
                                Cancel
                            </button>
                        </router-link>
                        <button class="mr-2 btn gradientbt" type="submit" @click="createFuelExpenses" :disabled="!(formstate.$dirty && formstate.$valid && this.docs)" v-if="$route.params && $route.params._id == '0'">
                            Save
                        </button>
                        <button class="btn gradientbt mr-5" type="submit" @click="updateFuelExpenses" :disabled="!((formstate.$dirty || isFileChange) && formstate.$valid)" v-if="$route.params && $route.params._id != '0'">
                            Update
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import axios from "axios";
import store from "../../../store";
import {
    formService,
    eventBus,
    fuelexpensesService,
    fileService,
} from "../../../services";
import {
    EVENTS
} from "../../../config";
import {
    USER_ROLES
} from "../../../config";
import {
    mapState
} from "vuex";

export default {
    name: "fuelExpensesCreate",
    changedFlag: "",
    data() {
        return {
            isCityDisable: false,
            isFileChange: false,
            ready: false,
            USER_ROLES: USER_ROLES,
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: "",
            EVENTS: EVENTS,
            formstate: {},
            fuelExpenses: {
                cityId: "",
                vehicleId: "",
                driverId: "",
                amount:"",
                disel:"",
            },
            oldFuelExpenses: {},
            fuelExpensesId: [],
            data: {},
            vehiclePoints: {},
            driverPoints: {},
            docs: null,
            citys: {},
        };
    },
    mounted: function () {
        this.getCityList();
    },

    methods: {
        fieldClassName: formService.fieldClassName,

        getVehiclePointList(cityId) {
            this.loading = true;
            const params = {};
            params.$select = ["_id", "vNumber"];
            params.status = true;
            params.cityId = cityId;
            let vehicleList = [];
            this.$vehicleDataRepository
                .list(params)
                .then((res) => {
                    this.loading = false;
                    res.data.docs.forEach((element) => {
                        // if (element.status == true && element.cityId === cityId) {
                        vehicleList.push({
                            name: element.vNumber,
                            id: element._id,
                        });
                        // }
                    });
                    vehicleList.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.vehiclePoints = vehicleList;
                })
                .catch((error) => {
                    this.loading = false;
                    this.$snotify.error("Get vehiclePoints list failed", "Error!");
                });
        },
        getDriverPointList(id) {
            this.loading = true;
            const params = {};
            let driverList = [];
            params.page = 1;
            params.limit = 1000;
            fuelexpensesService
                .getDrivers(id)
                .then((res) => {
                    this.loading = false;

                    res.response.forEach((element) => {
                        driverList.push({
                            name: element.firstName + " " + element.lastName,
                            id: element._id,
                        });
                    });
                    driverList.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.driverPoints = driverList;
                })
                .catch((error) => {
                    this.loading = false;
                });
        },
        getCityList() {
            if (this.$store.state.auth.user.role.key === "cityAdmin") {
                const {
                    _id,
                    cityName
                } = this.$store.state.auth.user.cityId;
                this.citys = [{
                    id: _id,
                    name: cityName
                }];
                this.fuelExpenses["cityId"] = _id;
                this.getCityId(_id);
                this.isCityDisable = true;
                return;
            }
            this.loading = true;
            const params = {};
            let cityList = [];
            // params.page = 1;
            // params.limit = 999;
            this.$cityRepository
                .collectionCitysList(params)
                .then((res) => {
                    this.loading = false;
                    res.data.response.forEach((element) => {
                        if (element.status === true) {
                            cityList.push({
                                name: element.cityName,
                                id: element._id,
                            });
                        }
                    });
                    cityList.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.citys = cityList;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("citys.requestFunction-error:", error);
                    this.$snotify.error("Get citys list failed", "Error!");
                });
        },

        getFuelExpenses() {
            const params = {};
            return this.$fuelExpenseDataRepository
                .find(this.$route.params._id, params)
                .then((response) => {
                    // this.fuelExpenses['driverId']=response.data.driverId;
                    
                    this.getCityId(response.data.cityId);
                    this.fuelExpenses = response.data;

                    this.oldFuelExpenses = _.cloneDeep(this.fuelExpenses);
                    // this.$store.dispatch("setBreadcrumbTitle", this.fuelExpenses.vNumber);
                })
                .catch((error) => {
                    this.$snotify.error("Get Fuel Expenses failed", "Error!");
                });
        },

        onDocumentchanged(event) {
            const fileName = document.getElementById("fileName");
            if (
                ["image/png", "image/jpeg", "image/jpg", "application/pdf"].includes(
                    event.target.files[0]["type"]
                )
            ) {
                if (event.target.files[0].size > 1024 * 1024 * 5) {
                    this.$snotify.error("File Size max limit of 5 MB", "Error!");
                    fileName.value = "";
                    event.preventDefault();
                    return;
                } else {
                    this.docs = event.target.files[0];
                    if (this.$route.params && this.$route.params._id != '0') {
                        this.changedFlag = true;
                    }
                    if (this.docs) {
                        this.isFileChange = true;
                    } else {
                        this.isFileChange = false;
                    }
                }
            } else {
                this.$snotify.error("Upload .png, .jpeg, .jpg, .pdf files", "Error!");
                fileName.value = "";
            }
        },

        async uploadDocument() {
            let docsArr = [];

            docsArr.push(this.docs);

            const response = await fileService.fileUpload(docsArr, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data;
        },

        async createFuelExpenses() {
            this.loading = true;

            let uploadedFileLocation = await this.uploadDocument();
            if (uploadedFileLocation !== "") {
                this.fuelExpenses.receipt = uploadedFileLocation[0].Location;
            }

            return fuelexpensesService
                .addFuelexpenses(this.fuelExpenses)
                .then((response) => {
                    this.loading = false;
                    this.flash = false;
                    this.$snotify.success(
                        `The Fuel Expense has been added successfully.`
                    );

                    this.$router.push("/fuelExpenses");
                })
                .catch((error) => {
                    this.loading = false;
                    this.$snotify.error(error, "Error!");
                });
        },

        clearChanges() {
            this.fuelExpenses = _.cloneDeep(this.oldFuelExpenses);
            this.formstate._reset();
        },
        async updateFuelExpenses() {
            const id = this.$route.params._id;
            this.loading = true;

            this.data = {};
            this.data["cityId"] = this.fuelExpenses["cityId"];
            this.data["vehicleId"] = this.fuelExpenses["vehicleId"];
            this.data["driverId"] = this.fuelExpenses["driverId"];
            this.data["disel"] = this.fuelExpenses["disel"];
            this.data["amount"] = this.fuelExpenses["amount"];

            this.data["status"] = this.fuelExpenses["status"];
            this.data["_id"] = this.$route.params._id;

            if (this.docs != null) {
                let uploadedFileLocation = await this.uploadDocument();
                if (uploadedFileLocation !== "") {
                    this.data["receipt"] = uploadedFileLocation[0].Location;
                }
            } else {
                this.data["receipt"] = this.fuelExpenses["receipt"];
            }

            return fuelexpensesService
                .updateFuelexpenses(id, this.data)
                .then((response) => {
                    this.loading = false;
                    this.flash = false;
                    this.formstate._reset();
                    this.oldFuelExpenses = _.cloneDeep(this.fuelExpenses);
                    this.$snotify.success(
                        `The Fuel Expense has been updated successfully.`
                    );
                    this.$router.push("/fuelExpenses");
                })
                .catch((error) => {
                    this.loading = false;
                    this.$snotify.error("Update Fuel Expenses failed", "Error!");
                    if (error.data.message.includes("must be one of")) {
                        this.flash = true;
                        this.flashType = "error";
                        this.flashMessage =
                            "That fuelExpenses name is not allowed. You must first update the list of allowed fuelExpenses names" +
                            " in the appy client and server config.";
                    }
                });
        },
        getCityId(cityId) {
            this.fuelExpenses.vehicleId = "";
            this.fuelExpenses.driverId = "";
            this.getVehiclePointList(cityId);
            this.getDriverPointList(cityId);
        },
    },

    created() {
        const promises = [];
        this.loading = true;

        if (this.$route.params && this.$route.params._id && this.$route.params._id != '0') {
            promises.push(this.getFuelExpenses());
        }
        Promise.all(promises)
            .then(() => {
                this.loading = false;
                this.ready = true;
            })
            .catch(() => {
                this.loading = false;
            });
    },
    beforeDestroy() {},

    fieldClassName: function (field) {
        if (!field) {
            return "";
        }
        if ((field.$touched || field.$submitted) && field.$valid) {
            return "has-success";
        }
        if ((field.$touched || field.$submitted) && field.$invalid) {
            return "has-danger";
        }
    },
};
</script>

<style scoped>
.required-field>label::after {
    content: "*";
    color: red;
    margin-left: 0.25rem;
}

.form-control-feedback {
    font-weight: 100;
    color: red;
    position: initial;
    text-align: left;
    height: auto;
    width: auto;
}

.has-danger {
    color: red;
}

.mt {
    margin-top: 7px;
}

.gradientbt {
    background: #3085d6;
    color: white;
}

.inputwrapper {
    position: relative;
}

.maps {
    position: absolute;
    top: 7px;
    right: 10px;
}
</style>



// WEBPACK FOOTER //
// fuelExpensesCreate.vue?355264a4